import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-task-unsaved-changes-dialog',
  templateUrl: './task-unsaved-changes-dialog.component.html',
  styleUrls: ['./task-unsaved-changes-dialog.component.css']
})
export class TaskUnsavedChangesDialogComponent {

  leavingPage: boolean = true;
  customWarning: string;

  constructor(
    private dialogRef: MatDialogRef<TaskUnsavedChangesDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.leavingPage = (data) ? data.leavingPage : true;
    this.customWarning = (data) ? data.customWarning : '';
  }

  stay(): void {
    this.dialogRef.close(false);
  }

  leave(): void {
    this.dialogRef.close(true);
  }
}
